// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"flight-takeoff"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M6.10495 4.01764L8.0368 3.5L14.7438 9.98507L20.2496 8.50981C21.0498 8.29539 21.8723 8.77027 22.0867 9.57047C22.3011 10.3707 21.8262 11.1932 21.026 11.4076L4.12233 15.9369L1.8623 11.3661L3.31119 10.9779L4.98794 12.5991L10.1073 11.2274L6.10495 4.01764Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M6.10495 4.01764L8.0368 3.5L14.7438 9.98507L20.2496 8.50981C21.0498 8.29539 21.8723 8.77027 22.0867 9.57047C22.3011 10.3707 21.8262 11.1932 21.026 11.4076L4.12233 15.9369L1.8623 11.3661L3.31119 10.9779L4.98794 12.5991L10.1073 11.2274L6.10495 4.01764Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 20H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-flight-takeoff')
export default class FlightTakeoffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flight-takeoff',
    }
  }
}
